module.exports = __webpack_public_path__ + "img/trafficflow.6d8e62d6.png";